import { Dialog, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { mobileMenuPanel, mobileMenuContent, navLinkMobile } from "../../utils/styles";
import { MenuItem, MenuItemRenderer } from "./MenuItemRenderer";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  menuItems: MenuItem[];
}

// Flatten menu items for mobile display
function flattenMenuItems(items: MenuItem[]): MenuItem[] {
  return items.reduce<MenuItem[]>((acc, item) => {
    if (item.children) {
      return acc.concat(item.children);
    } else {
      return acc.concat(item);
    }
  }, []);
}

export function MobileMenu({ isOpen, onClose, menuItems }: MobileMenuProps) {
  const flatMenuItems = flattenMenuItems(menuItems);

  return (
    <Dialog
      as="div"
      className="lg:hidden"
      open={isOpen}
      onClose={onClose}
    >
      <div className="fixed inset-0 z-10" />
      <DialogPanel className={mobileMenuPanel}>
        <div className="flex items-center justify-between">
          <a href="/" onClick={onClose}>
            <span className="sr-only">EVTCC</span>
            <img
              className="h-16 w-auto"
              src="/evtcc-logo.png"
              alt="EVTCC Logo"
            />
          </a>
          <button
            type="button"
            className="inline-flex items-center justify-center"
            onClick={onClose}
          >
            <span className="sr-only">Close main menu</span>
            <XMarkIcon
              className="h-8 w-8 cursor-pointer rounded-md border border-white text-white"
              aria-hidden="true"
            />
          </button>
        </div>

        <div className="mt-6 flow-root">
          <div className="-my-6 divide-y divide-gray-500/10">
            <div className={mobileMenuContent}>
              {flatMenuItems.map(item => (
                <MenuItemRenderer
                  key={item.name}
                  item={item}
                  className={navLinkMobile}
                  onClick={onClose}
                />
              ))}
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
}